import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {OG_PATH} from "@/content";

const slug = 'emergency-electrical-network-repairs-sydney';
const serviceId = 5
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: "Emergency Electrical Network Repairs",
        description: "Providing rapid response to urgent service line issues, ensuring minimal downtime and safety.",
        keywords: "emergency electrical repairs Sydney, urgent service line repair, licensed electricians Sydney, power outage repair, electrical fault response, safe emergency electrical services, professional electricians Sydney",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Emergency Electrical Network Repairs',
    description: 'Providing rapid response to urgent service line issues, ensuring minimal downtime and safety.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
